import {Component, OnInit} from '@angular/core';
import {Tile} from '../../shared/models/tile.model';
import {TileCardComponent} from '../../shared/components/tile-card/tile-card.component';
import {RoundButtonComponent} from '../../shared/components/round-button/round-button.component';
import {CommonModule} from '@angular/common';
import {ThemeService} from '../../core/services/theme.service';
import {LangSelectorComponent} from '../../shared/components/lang-selector/lang-selector.component';
import {
  ModalCheckInLegalAdviceComponent
} from '../../shared/components/modal-check-in-legal-advice/modal-check-in-legal-advice.component';
import {
  ModalCheckInHostsCountComponent
} from '../../shared/components/modal-check-in-hosts-count/modal-check-in-hosts-count.component';
import {ReservationService} from '../../core/api/reservation.service';
import {forkJoin, of, switchMap} from 'rxjs';
import {
  checkInRequiredAndNoOneCheckedIn,
  checkInRequiredAndNotEveryoneCheckedIn, checkinRequiredForOpen, hasCheckIn
} from '../../shared/models/check-ins.model';
import {HoomvipStorage} from '../../core/hoomvip-storage/hoomvip-storage.service';
import {
  expiredReservation,
  getAppSectionName,
  getReservationPlansUrl, Reservation
} from '../../shared/models/reservation.model';
import {LogoutButtonComponent} from '../../shared/components/logout-button/logout-button.component';
import {BrandingContactAction, BrandingContactService, openAction} from '../../core/services/branding-contact.service';
import {CheckInFlowService} from '../../core/services/check-in-flow.service';
import {CheckInFlowData, pendingCheckIns} from '../../shared/models/check-in-flow.model';
import {RouterService} from '../../core/services/router.service';
import {TileService} from '../../core/services/tile.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: true,
  imports: [CommonModule, TileCardComponent, RoundButtonComponent, LangSelectorComponent, ModalCheckInLegalAdviceComponent, ModalCheckInHostsCountComponent, LogoutButtonComponent]
})
export class HomeComponent implements OnInit {
  protected readonly pendingCheckIns = pendingCheckIns;
  flow!: CheckInFlowData;
  reservation!: Reservation;
  language = 'Español';

  activeModal = '';
  showModal = false;
  topActions: BrandingContactAction[] = [];

  tiles: Tile[] = [];

  constructor(
    private theme: ThemeService,
    private reservationService: ReservationService,
    private hoomvipStorage: HoomvipStorage,
    private contact: BrandingContactService,
    private router: RouterService,
    private checkInFlowService: CheckInFlowService,
    private tileService: TileService,
  ) {
  }

  ngOnInit(): void {
    this.setTopActions();

    this.reservationService.getReservation().pipe(
      switchMap((reservation) =>
        forkJoin({
          flow: this.checkInFlowService.get(reservation),
          reservation: of(reservation),
        })
      )
    ).subscribe({
      next: ({flow, reservation}) => {
        this.flow = flow;
        this.reservation = reservation;
        this.tiles = this.tileService.setTiles(flow, reservation, this.theme.getTileOrder());
        this.setModals(flow, reservation);
      },
      error: (error) => {
        console.error('Error loading home data:', error);
      }
    });
  }

  setTopActions() {
    this.contact.loadBrandingContactActions().subscribe(actions => {
      this.topActions = actions;
    });
  }

  getLogoPath(): string {
    return this.theme.getLogoPath();
  }

  onTileClick(tile: Tile) {
    console.log('Click en', tile.id);
    if (tile.id == 'checkin') {
      this.showModal = true;
      return;
    }
    if (tile.id == 'abrir') {
      if (checkinRequiredForOpen(this.reservation) && (checkInRequiredAndNoOneCheckedIn(this.flow, this.reservation) || checkInRequiredAndNotEveryoneCheckedIn(this.flow, this.reservation))) {
        this.showModal = true;
        return;
      }
      this.router.navigateByUrl('/open');
      return;
    }
    this.router.navigateByUrl(tile.routerLink || '');
  }

  closeCheckinLegalAdviceModal() {
    this.showModal = false;
  }

  closeCheckinPendingHostModal() {
    this.showModal = false;
  }

  private setModals(flow: CheckInFlowData, reservation: Reservation) {
    if (expiredReservation(reservation)) {
      return;
    }
    if (!hasCheckIn(reservation.data.apartment)) {
      return;
    }
    if (checkInRequiredAndNoOneCheckedIn(flow, reservation)) {
      this.activeModal = 'checkin-legal-advice';
      if (!this.hoomvipStorage.existsCheckingWarning()) {
        this.showModal = true;
        this.hoomvipStorage.markCheckingWarning();
      }

      return;
    }
    if (checkInRequiredAndNotEveryoneCheckedIn(flow, reservation)) {
      this.activeModal = 'checkin-pending-host';
      if (!this.hoomvipStorage.existsCheckingWarning()) {
        this.showModal = true;
        this.hoomvipStorage.markCheckingWarning();
      }
      return;
    }
    if (flow.checkinCompleted && flow.hasPendingDeposit) {
      this.activeModal = 'checkin-legal-advice';
      this.showModal = true;
    }
  }

  protected readonly openAction = openAction;
}
